import { render } from "./TaxInformationSectionAttachmentForm.vue?vue&type=template&id=d8e2c5ac"
import script from "./TaxInformationSectionAttachmentForm.vue?vue&type=script&lang=js"
export * from "./TaxInformationSectionAttachmentForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__